export default __webpack_public_path__ + "static/media/Icons_Yacht Icon.bcb6eb6b.svg";